import { createElement } from "react";
import { comparePrimitives, int32ToString, equals, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { singleton as singleton_1, empty as empty_1, cons, fold, collect as collect_1, reverse, sortBy, length, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { EventTabModule_label, WorkflowStepModule_tabs, WorkflowStepModule_all, WorkflowStepModule_label, WorkflowStepModule_stepNumber, WorkflowStepModule_icon, WorkflowStep, WorkflowStepModule_defaultTab, WorkflowStepModule_fromTab } from "../Router.js";
import { empty as empty_2, append, map, singleton, collect, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { Msg } from "../App/Messages.js";
import { formatDate, t as t_1 } from "../Lang.js";
import { App_loadingEvent, App_backToDashboard, Guests_deleteConfirmMsg, App_checkMark } from "../Shared/Tr.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { TagFormat_parse } from "../Shared/Types.js";
import { empty, add, contains } from "../fable_modules/fable-library-js.4.28.0/Set.js";
import { confirmDialog } from "./Components.js";
import { view as view_1 } from "./ImportWizard.js";
import { map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.28.0/Option.js";
import { view as view_2 } from "./GuestList.js";
import { view as view_3 } from "./Relationships.js";
import { view as view_4 } from "./TagManagement.js";
import { view as view_5 } from "./GuestEdit.js";
import { view as view_6 } from "./TableLayout.js";
import { view as view_7 } from "./FloorPlanEditor.js";
import { view as view_8 } from "./RuleEditor.js";
import { view as view_9 } from "./ArrangementView.js";
import { view as view_10 } from "./ArrangementDetail.js";
import { view as view_11 } from "./ExportView.js";
import { view as view_12 } from "./SharingView.js";
import { view as view_13 } from "./RsvpDashboard.js";
import { init } from "../Pages/Event/State.js";

function placeCardIcon() {
    let elements;
    return createElement("svg", createObj(ofArray([["viewBox", (((((0 + " ") + 0) + " ") + 32) + " ") + 32], ["width", 28], ["height", 28], (elements = ofArray([createElement("path", {
        d: "M6 24 L8 10 L24 10 L26 24 Z",
        fill: "rgba(255,255,255,0.25)",
        stroke: "white",
        strokeWidth: 1.5,
        strokeLinejoin: "round",
    }), createElement("line", {
        x1: 7,
        y1: 17,
        x2: 25,
        y2: 17,
        stroke: "rgba(255,255,255,0.5)",
        strokeWidth: 1,
    }), createElement("text", {
        x: 16,
        y: 15,
        fill: "white",
        fontSize: 7,
        fontFamily: "\'Cormorant Garamond\', cursive",
        fontStyle: "italic",
        textAnchor: "middle",
        children: "Sarah",
    })]), ["children", reactApi.Children.toArray(Array.from(elements))])])));
}

function isStepCompleted(state, step) {
    switch (step.tag) {
        case 1:
            return length(state.Tables) > 0;
        case 2:
            return length(state.Rules) > 0;
        case 3:
            return length(state.Arrangements) > 0;
        case 4:
            return length(state.Arrangements) > 0;
        case 5:
            return state.RsvpConfig != null;
        default:
            return length(state.Guests) > 0;
    }
}

function workflowStepper(currentTab, state, dispatch) {
    let elems_2;
    const currentStep = WorkflowStepModule_fromTab(currentTab);
    return createElement("div", createObj(ofArray([["className", "workflow-stepper"], (elems_2 = toList(delay(() => collect((step) => {
        let elems_1, elems;
        const isActive = equals(step, currentStep);
        const isCompleted = isStepCompleted(state, step);
        return singleton(createElement("div", createObj(ofArray([["className", ("wf-step" + (isActive ? " wf-step-active" : "")) + (isCompleted ? " wf-step-completed" : "")], ["onClick", (_arg) => {
            dispatch(new Msg(46, [WorkflowStepModule_defaultTab(step)]));
        }], (elems_1 = [createElement("div", createObj(ofArray([["className", "wf-step-icon"], (elems = toList(delay(() => ((isCompleted && !isActive) ? singleton(createElement("span", {
            className: "wf-step-check",
            children: t_1(App_checkMark),
        })) : (equals(step, new WorkflowStep(4, [])) ? singleton(placeCardIcon()) : singleton(createElement("span", {
            children: WorkflowStepModule_icon(step),
        })))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", {
            className: "wf-step-number",
            children: int32ToString(WorkflowStepModule_stepNumber(step)),
        }), createElement("div", {
            className: "wf-step-title",
            children: WorkflowStepModule_label(step),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    }, WorkflowStepModule_all))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function subTabBar(currentTab, dispatch) {
    let elems;
    const stepTabs = WorkflowStepModule_tabs(WorkflowStepModule_fromTab(currentTab));
    if (length(stepTabs) <= 1) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(ofArray([["className", "sub-tab-bar"], (elems = toList(delay(() => map((tab) => createElement("button", {
            className: equals(tab, currentTab) ? "sub-tab-item active" : "sub-tab-item",
            children: EventTabModule_label(tab),
            onClick: (_arg) => {
                dispatch(new Msg(46, [tab]));
            },
        }), stepTabs))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function collectAllTags(guests) {
    let list_1;
    return sortBy((t) => t.toLowerCase(), reverse(((list_1 = collect_1((g) => TagFormat_parse(g.Tags), guests), fold((tupledArg, tag) => {
        const seen = tupledArg[0];
        const acc = tupledArg[1];
        const key = tag.toLowerCase();
        if (contains(key, seen)) {
            return [seen, acc];
        }
        else {
            return [add(key, seen), cons(tag, acc)];
        }
    }, [empty({
        Compare: comparePrimitives,
    }), empty_1()], list_1)))[1]), {
        Compare: comparePrimitives,
    });
}

function guestsPanel(state, dispatch) {
    let elems_3;
    const allTags = collectAllTags(state.Guests);
    return createElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
        let matchValue, guestId;
        return append((matchValue = state.ShowDeleteConfirm, (matchValue == null) ? singleton(defaultOf()) : ((guestId = matchValue, singleton(confirmDialog(t_1(Guests_deleteConfirmMsg), () => {
            dispatch(new Msg(55, [guestId]));
        }, () => {
            dispatch(new Msg(58, []));
        }))))), delay(() => {
            let elems_2;
            return singleton(createElement("div", createObj(ofArray([["className", "guest-content-layout"], (elems_2 = toList(delay(() => {
                let elems;
                return append(singleton(createElement("div", createObj(ofArray([["className", "guest-main"], (elems = toList(delay(() => append(state.ShowImportWizard ? singleton(view_1(state.ImportState, defaultArg(map_1((e) => e.Id, state.Event), ""), dispatch)) : empty_2(), delay(() => append(singleton(view_2(state, dispatch)), delay(() => append(singleton(view_3(state, dispatch)), delay(() => singleton(view_4(state, dispatch)))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                    let elems_1;
                    const matchValue_1 = state.GuestEditForm;
                    return (matchValue_1 == null) ? singleton(defaultOf()) : singleton(createElement("div", createObj(ofArray([["className", "guest-edit-sidebar"], (elems_1 = [view_5(matchValue_1, allTags, dispatch)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

function tabContent(tab, state, dispatch) {
    let elems;
    switch (tab.tag) {
        case 1:
            return view_6(state, dispatch);
        case 2:
            return view_7(state, dispatch);
        case 3:
            return view_8(state, dispatch);
        case 4:
            return createElement("div", createObj(singleton_1((elems = toList(delay(() => append(singleton(view_9(state, dispatch)), delay(() => ((state.SelectedArrangementId == null) ? singleton(defaultOf()) : singleton(view_10(state, dispatch))))))), ["children", reactApi.Children.toArray(Array.from(elems))]))));
        case 5:
            return view_11(state, dispatch);
        case 6:
            return view_12(state, dispatch);
        case 7:
            return view_13(state, dispatch);
        default:
            return guestsPanel(state, dispatch);
    }
}

export function view(model, eventId, tab, dispatch) {
    let elems_3;
    const state = defaultArg(model.EventState, init());
    return createElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "mb-2"], (elems = [createElement("a", {
            href: "#/",
            children: t_1(App_backToDashboard),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue, elems_2, event, elems_1;
            return append((matchValue = state.Event, (matchValue == null) ? singleton(createElement("div", createObj(ofArray([["className", "page-header"], (elems_2 = [createElement("h2", {
                children: t_1(App_loadingEvent),
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : ((event = matchValue, singleton(createElement("div", createObj(ofArray([["className", "page-header"], (elems_1 = toList(delay(() => append(singleton(createElement("h2", {
                children: event.Name,
            })), delay(() => {
                const matchValue_1 = event.Date;
                return (matchValue_1 == null) ? singleton(defaultOf()) : singleton(createElement("span", {
                    className: "text-muted",
                    children: formatDate(matchValue_1),
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))))), delay(() => append(singleton(workflowStepper(tab, state, dispatch)), delay(() => append(singleton(subTabBar(tab, dispatch)), delay(() => singleton(tabContent(tab, state, dispatch))))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

